import React, { useState } from "react";

import "./Step6Review.css";


const API_URL =
  "https://abnbtrust.org/api/register-details/";


function Step6Review({
  formData = {},
  prevStep,
  onBack,
}) {

  const [confirmed, setConfirmed] =
    useState(false);

  const [saving, setSaving] =
    useState(false);


  // ==========================================================
  // GET VALUE
  // ==========================================================

  const getValue = (...keys) => {

    for (const key of keys) {

      const value = formData?.[key];

      if (
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ""
      ) {
        return String(value);
      }
    }

    return "-";
  };


  // ==========================================================
  // GET PASSPORT PHOTO NAME
  // ==========================================================

  const getPassportName = () => {

    const file =
      formData?.passportFile ||
      formData?.passport_photo ||
      formData?.passportPhoto;

    if (
      file &&
      typeof file === "object" &&
      file.name
    ) {
      return file.name;
    }

    return (
      formData?.passportFileName ||
      formData?.passportPhotoName ||
      "-"
    );
  };


  // ==========================================================
  // BACK
  // ==========================================================

  const handleBack = () => {

    if (typeof onBack === "function") {

      onBack();

      return;
    }

    if (typeof prevStep === "function") {

      prevStep();
    }
  };


  // ==========================================================
  // SAVE REGISTRATION
  // ==========================================================

  const handlePayment = async () => {

    if (!confirmed) {

      alert(
        "Please confirm that all the information is correct."
      );

      return;
    }


    // --------------------------------------------------------
    // PASSPORT PHOTO
    // --------------------------------------------------------

    const passportFile =
      formData?.passportFile ||
      formData?.passport_photo ||
      formData?.passportPhoto;


    if (
      !passportFile ||
      typeof passportFile !== "object"
    ) {

      alert(
        "Please upload your passport photo before continuing."
      );

      return;
    }


    setSaving(true);


    try {

      // ======================================================
      // CREATE FORM DATA
      // ======================================================

      const data = new FormData();


      // ======================================================
      // STEP 1 - MOBILE / OTP
      // ======================================================

      data.append(
        "mobile_number",
        getValue(
          "mobileNumber",
          "mobile",
          "phone",
          "mobile_number"
        ) === "-"
          ? ""
          : getValue(
              "mobileNumber",
              "mobile",
              "phone",
              "mobile_number"
            )
      );


      data.append(
        "otp",
        getValue(
          "otp",
          "enteredOtp"
        ) === "-"
          ? ""
          : getValue(
              "otp",
              "enteredOtp"
            )
      );


      // ======================================================
      // PERSONAL DETAILS
      // ======================================================

      data.append(
        "full_name",
        getValue(
          "fullName",
          "name",
          "memberName"
        ) === "-"
          ? ""
          : getValue(
              "fullName",
              "name",
              "memberName"
            )
      );


      data.append(
        "father_name",
        getValue(
          "fatherName",
          "fathersName",
          "fatherHusbandName"
        ) === "-"
          ? ""
          : getValue(
              "fatherName",
              "fathersName",
              "fatherHusbandName"
            )
      );


      data.append(
        "date_of_birth",
        getValue(
          "dateOfBirth",
          "dob"
        ) === "-"
          ? ""
          : getValue(
              "dateOfBirth",
              "dob"
            )
      );


      data.append(
        "gender",
        getValue("gender") === "-"
          ? ""
          : getValue("gender")
      );


      data.append(
        "marital_status",
        getValue(
          "maritalStatus"
        ) === "-"
          ? ""
          : getValue(
              "maritalStatus"
            )
      );


      data.append(
        "community",
        getValue(
          "community"
        ) === "-"
          ? ""
          : getValue(
              "community"
            )
      );


      data.append(
        "occupation",
        getValue(
          "occupation"
        ) === "-"
          ? ""
          : getValue(
              "occupation"
            )
      );


      data.append(
        "email",
        getValue(
          "email",
          "emailId",
          "emailID"
        ) === "-"
          ? ""
          : getValue(
              "email",
              "emailId",
              "emailID"
            )
      );


      // ======================================================
      // ADDRESS
      // ======================================================

      data.append(
        "state",
        getValue("state") === "-"
          ? ""
          : getValue("state")
      );


      data.append(
        "district",
        getValue("district") === "-"
          ? ""
          : getValue("district")
      );


      data.append(
        "assembly_constituency",
        getValue(
          "assemblyConstituency",
          "constituency",
          "assembly_constituency"
        ) === "-"
          ? ""
          : getValue(
              "assemblyConstituency",
              "constituency",
              "assembly_constituency"
            )
      );


      data.append(
        "mandal",
        getValue("mandal") === "-"
          ? ""
          : getValue("mandal")
      );


      data.append(
        "village_town",
        getValue(
          "villageTown",
          "village",
          "town",
          "village_town"
        ) === "-"
          ? ""
          : getValue(
              "villageTown",
              "village",
              "town",
              "village_town"
            )
      );


      data.append(
        "pin_code",
        getValue(
          "pinCode",
          "pincode",
          "pin",
          "pin_code"
        ) === "-"
          ? ""
          : getValue(
              "pinCode",
              "pincode",
              "pin",
              "pin_code"
            )
      );


      // ======================================================
      // DOCUMENTS
      // ======================================================

      data.append(
        "pan_number",
        getValue(
          "panNumber",
          "panNo",
          "pan",
          "pan_number"
        ) === "-"
          ? ""
          : getValue(
              "panNumber",
              "panNo",
              "pan",
              "pan_number"
            )
      );


      data.append(
        "aadhaar_number",
        getValue(
          "aadhaarNumber",
          "aadhaarNo",
          "aadhaar",
          "aadhaar_number"
        ) === "-"
          ? ""
          : getValue(
              "aadhaarNumber",
              "aadhaarNo",
              "aadhaar",
              "aadhaar_number"
            )
      );


      // Actual file
      data.append(
        "passport_photo",
        passportFile
      );


      // ======================================================
      // NOMINEE
      // ======================================================

      data.append(
        "nominee_full_name",
        getValue(
          "nomineeFullName",
          "nomineeName",
          "nominee_full_name"
        ) === "-"
          ? ""
          : getValue(
              "nomineeFullName",
              "nomineeName",
              "nominee_full_name"
            )
      );


      data.append(
        "nominee_relationship",
        getValue(
          "nomineeRelationship",
          "relationship",
          "nominee_relationship"
        ) === "-"
          ? ""
          : getValue(
              "nomineeRelationship",
              "relationship",
              "nominee_relationship"
            )
      );


      data.append(
        "nominee_date_of_birth",
        getValue(
          "nomineeDateOfBirth",
          "nomineeDob",
          "nomineeDOB",
          "nominee_date_of_birth"
        ) === "-"
          ? ""
          : getValue(
              "nomineeDateOfBirth",
              "nomineeDob",
              "nomineeDOB",
              "nominee_date_of_birth"
            )
      );


      data.append(
        "nominee_mobile_number",
        getValue(
          "nomineeMobileNumber",
          "nomineeMobile",
          "nomineePhone",
          "nominee_mobile_number"
        ) === "-"
          ? ""
          : getValue(
              "nomineeMobileNumber",
              "nomineeMobile",
              "nomineePhone",
              "nominee_mobile_number"
            )
      );


      // ======================================================
      // BANK
      // ======================================================

      data.append(
        "account_holder_name",
        getValue(
          "accountHolderName",
          "accountName",
          "bankAccountHolderName",
          "account_holder_name"
        ) === "-"
          ? ""
          : getValue(
              "accountHolderName",
              "accountName",
              "bankAccountHolderName",
              "account_holder_name"
            )
      );


      data.append(
        "bank_name",
        getValue(
          "bankName",
          "bank_name"
        ) === "-"
          ? ""
          : getValue(
              "bankName",
              "bank_name"
            )
      );


      data.append(
        "account_number",
        getValue(
          "accountNumber",
          "accountNo",
          "bankAccountNumber",
          "account_number"
        ) === "-"
          ? ""
          : getValue(
              "accountNumber",
              "accountNo",
              "bankAccountNumber",
              "account_number"
            )
      );


      data.append(
        "ifsc_code",
        getValue(
          "ifscCode",
          "ifsc",
          "ifsc_code"
        ) === "-"
          ? ""
          : getValue(
              "ifscCode",
              "ifsc",
              "ifsc_code"
            )
      );


      data.append(
        "bank_branch",
        getValue(
          "bankBranch",
          "branchName",
          "bank_branch"
        ) === "-"
          ? ""
          : getValue(
              "bankBranch",
              "branchName",
              "bank_branch"
            )
      );


      // ======================================================
      // MEMBERSHIP FEE
      // ======================================================

      data.append(
        "membership_fee",
        "1299.00"
      );


      // ======================================================
      // DEBUG - SHOW WHAT IS BEING SENT
      // ======================================================

      console.log(
        "=========================================="
      );

      console.log(
        "SENDING REGISTRATION TO DJANGO"
      );

      console.log(
        "=========================================="
      );


      for (
        const [key, value]
        of data.entries()
      ) {

        if (value instanceof File) {

          console.log(
            `${key}:`,
            value.name
          );

        } else {

          console.log(
            `${key}:`,
            value
          );
        }
      }


      // ======================================================
      // SEND TO DJANGO
      // ======================================================

      const response =
        await fetch(
          API_URL,
          {
            method: "POST",
            body: data,
          }
        );


      const result =
        await response.json();


      console.log(
        "DJANGO RESPONSE:",
        result
      );


      // ======================================================
      // DJANGO ERROR
      // ======================================================

      if (!response.ok) {

        console.error(
          "REGISTRATION API ERROR:",
          result
        );


        let errorMessage =
          "Unable to save registration.";


        if (result?.errors) {

          errorMessage =
            Object.entries(
              result.errors
            )
            .map(
              ([field, errors]) =>
                `${field}: ${
                  Array.isArray(errors)
                    ? errors.join(", ")
                    : errors
                }`
            )
            .join("\n");
        }


        alert(errorMessage);

        setSaving(false);

        return;
      }


      // ======================================================
      // SUCCESS
      // ======================================================

      if (result?.success) {

        console.log(
          "REGISTRATION SAVED SUCCESSFULLY"
        );


        // Save registration ID for payment
        localStorage.setItem(
          "registrationId",
          String(
            result.registration_id
          )
        );


        // Save server response
        localStorage.setItem(
          "serverRegistration",
          JSON.stringify(
            result.data
          )
        );


        alert(
          "Application saved successfully. Proceeding to payment."
        );


        // Only navigate AFTER Django saves it
        window.location.href =
          "/membership-payment";


        return;
      }


      alert(
        "Registration could not be completed."
      );

      setSaving(false);

    } catch (error) {

      console.error(
        "REGISTRATION CONNECTION ERROR:",
        error
      );


      alert(
        "Unable to connect to Django server. Please make sure Django is running."
      );


      setSaving(false);
    }

  };


  // ==========================================================
  // REVIEW ITEM
  // ==========================================================

  const ReviewItem = ({
    label,
    value,
    uploaded = false,
  }) => {

    return (

      <div className="review-item">

        <span className="review-label">
          {label}
        </span>


        <span
          className={
            uploaded
              ? "review-value review-uploaded"
              : "review-value"
          }
        >

          {uploaded && value !== "-"
            ? "✓ "
            : ""}

          {value}

        </span>

      </div>

    );
  };


  // ==========================================================
  // REVIEW SECTION
  // ==========================================================

  const ReviewSection = ({
    title,
    children,
  }) => {

    return (

      <section className="review-section">

        <div className="review-section-header">

          <h2>
            {title}
          </h2>

        </div>


        <div className="review-grid">

          {children}

        </div>

      </section>

    );
  };


  // ==========================================================
  // PAGE
  // ==========================================================

  return (

    <div className="step6-page">

      <div className="step6-container">


        {/* ====================================================
            PERSONAL DETAILS
        ==================================================== */}

        <ReviewSection
          title="Personal Details"
        >

          <ReviewItem
            label="Name"
            value={getValue(
              "name",
              "fullName",
              "memberName"
            )}
          />


          <ReviewItem
            label="Father's Name"
            value={getValue(
              "fatherName",
              "fathersName",
              "fatherHusbandName"
            )}
          />


          <ReviewItem
            label="Date of Birth"
            value={getValue(
              "dateOfBirth",
              "dob"
            )}
          />


          <ReviewItem
            label="Gender"
            value={getValue(
              "gender"
            )}
          />


          <ReviewItem
            label="Marital Status"
            value={getValue(
              "maritalStatus"
            )}
          />


          <ReviewItem
            label="Community"
            value={getValue(
              "community"
            )}
          />


          <ReviewItem
            label="Occupation"
            value={getValue(
              "occupation"
            )}
          />


          <ReviewItem
            label="Email"
            value={getValue(
              "email",
              "emailId",
              "emailID"
            )}
          />


          <ReviewItem
            label="Mobile Number"
            value={getValue(
              "mobileNumber",
              "mobile",
              "phone"
            )}
          />

        </ReviewSection>


        {/* ====================================================
            ADDRESS DETAILS
        ==================================================== */}

        <ReviewSection
          title="Address Details"
        >

          <ReviewItem
            label="State"
            value={getValue(
              "state"
            )}
          />


          <ReviewItem
            label="District"
            value={getValue(
              "district"
            )}
          />


          <ReviewItem
            label="Assembly Constituency"
            value={getValue(
              "assemblyConstituency",
              "constituency"
            )}
          />


          <ReviewItem
            label="Mandal"
            value={getValue(
              "mandal"
            )}
          />


          <ReviewItem
            label="Village / Town"
            value={getValue(
              "villageTown",
              "village",
              "town"
            )}
          />


          <ReviewItem
            label="PIN Code"
            value={getValue(
              "pinCode",
              "pincode",
              "pin"
            )}
          />

        </ReviewSection>


        {/* ====================================================
            DOCUMENT DETAILS
        ==================================================== */}

        <ReviewSection
          title="Document Details"
        >

          


          <ReviewItem
            label="Passport Size Photo"
            value={getPassportName()}
            uploaded
          />

        </ReviewSection>


        {/* ====================================================
            NOMINEE DETAILS
        ==================================================== */}

        <ReviewSection
          title="Nominee Details"
        >

          <ReviewItem
            label="Nominee Name"
            value={getValue(
              "nomineeName",
              "nomineeFullName"
            )}
          />


          <ReviewItem
            label="Relationship"
            value={getValue(
              "nomineeRelationship",
              "relationship"
            )}
          />


          <ReviewItem
            label="Date of Birth"
            value={getValue(
              "nomineeDateOfBirth",
              "nomineeDob",
              "nomineeDOB"
            )}
          />


          <ReviewItem
            label="Mobile Number"
            value={getValue(
              "nomineeMobileNumber",
              "nomineeMobile",
              "nomineePhone"
            )}
          />

        </ReviewSection>


        {/* ====================================================
            BANK DETAILS
        ==================================================== */}

        <ReviewSection
          title="Bank Details"
        >

          <ReviewItem
            label="Account Holder Name"
            value={getValue(
              "accountHolderName",
              "accountName"
            )}
          />


          <ReviewItem
            label="Bank Name"
            value={getValue(
              "bankName"
            )}
          />


          <ReviewItem
            label="Account Number"
            value={getValue(
              "accountNumber",
              "accountNo"
            )}
          />


          <ReviewItem
            label="IFSC Code"
            value={getValue(
              "ifscCode",
              "ifsc"
            )}
          />


          <ReviewItem
            label="Bank Branch"
            value={getValue(
              "bankBranch",
              "branchName"
            )}
          />

        </ReviewSection>


        {/* ====================================================
            MEMBERSHIP
        ==================================================== 

        <ReviewSection
          title="Membership"
        >

          <ReviewItem
            label="Membership Fee"
            value="₹1299"
          />


          <ReviewItem
            label="Payment Status"
            value="Pending"
          />

        </ReviewSection>
        */}


        {/* ====================================================
            CONFIRMATION
        ==================================================== */}

        <div className="review-confirmation">

          <label>

            <input
              type="checkbox"
              checked={confirmed}
              onChange={(event) =>
                setConfirmed(
                  event.target.checked
                )
              }
              disabled={saving}
            />


            <span>
              I confirm that all the above information is correct.
            </span>

          </label>


          <p>
            I agree to the Terms &amp; Conditions and Privacy Policy.
          </p>

        </div>


        {/* ====================================================
            ACTION BUTTONS
        ==================================================== */}

        <div className="review-actions">

          <button
            type="button"
            className="review-back-button"
            onClick={handleBack}
            disabled={saving}
          >
            BACK
          </button>


          <button
            type="button"
            className="review-payment-button"
            onClick={handlePayment}
            disabled={saving}
          >

            {saving
              ? "SAVING APPLICATION..."
              : "PROCEED TO PAYMENT ₹1299"
            }

          </button>

        </div>


        {/* ====================================================
            SECURITY
        ==================================================== */}

        <div className="secure-payment">

          🔒 Your information is securely protected.

        </div>


      </div>

    </div>

  );
}


export default Step6Review;